import Logo from '@/components/common/Logo'
import { useTranslation } from '@/hooks/useTranslation'
import { Box, Button, Container, Stack, Typography } from '@mui/material'
import { useAuthContext } from '../context'

type Props = {}

const NoInterface = (props: Props) => {
  const { logout } = useAuthContext()
  const { t } = useTranslation()

  return (
    <Stack
      minHeight="100vh"
      justifyContent="center"
      alignItems="center"
      bgcolor="background.main"
    >
      <Container>
        <Stack alignItems="center">
          <Stack>
            <Box>
              <Box sx={{ textAlign: 'center', marginBottom: '14.05px' }}>
                <Logo />
              </Box>
              <Box>
                <Typography
                  sx={{
                    textAlign: 'center',
                    alignItems: 'center',
                    color: 'common.white',
                    marginBottom: '23px',
                    fontSize: '18px',
                    lineHeight: '115%',
                    letterSpacing: '0.02em',
                    opacity: '0.5',
                  }}
                >
                  {t('authNoInterfaceTitle')}
                </Typography>
              </Box>
              <Box>
                <Typography
                  sx={{
                    fontSize: '12px',
                    lineHeight: '115%',
                    fontStyle: 'normal',
                    textAlign: 'center',
                    alignItems: 'center',
                    color: 'common.white',
                  }}
                >
                  {t('authNoInterfaceDescription')}
                </Typography>
              </Box>
            </Box>
          </Stack>
          <Stack>
            <Box
              sx={{
                padding: '10px 32px',
                marginTop: '19px',
              }}
            >
              <Button
                variant="contained"
                type="submit"
                size="large"
                onClick={() => logout()}
                sx={{
                  width: '155px',
                  height: '35px',
                  borderRadius: '4px',
                  backgroundColor: 'brand.main',
                  '&:hover': {
                    backgroundColor: '#004F4B',
                  },
                }}
              >
                {t('authNoInterfaceBackToLogin')}
              </Button>
            </Box>
          </Stack>
        </Stack>
      </Container>
    </Stack>
  )
}

export default NoInterface
